import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const iphoneScreenshotExample: TemplateDefinition = {
  mode: "compose",
  slug: "iphone-screenshot",
  version: 1,
  title: "Desktop use",
  description: "Determine next action",
  thumbnailUuid: BASE_ASSETS.iphoneScreenshot.uuid,
  assets: [BASE_ASSETS.iphoneScreenshot],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.iphoneScreenshot.uuid,
              extension: BASE_ASSETS.iphoneScreenshot.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Where should I click to learn more about geometry and why?",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: null,
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
